import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InputIcon(props: IconProps) {
    return <Icon {...props} iconKey={"input"}/>
}
